// extracted by mini-css-extract-plugin
module.exports = {"Title":"ResourceMetadata_Title__GwHET","CreatorName":"ResourceMetadata_CreatorName__kX8Cb","TracksDetails":"ResourceMetadata_TracksDetails__1GAj5"};